export const environment = {
  production: true,
  instance: 'numen',
  name: 'prod',
  hmr: false,
  url_back: 'https://api-nex.numenservices.fr/api',
  enable_lre: false,
  tokenInStorage: 'token',
  impersonatingToken: 'impersonatingToken',
  impersonatingUser: 'impersonatingUser',
  userIdInStorage: 'userID',
  pwdInStorage: 'userPwd',
  customerIdInStorage: 'customerID',
  langInStorage: 'language',
  searchCriteriasInStorage: 'searchCriterias',
  consultCriteriasInStorage: 'consultCriterias',
  addressDatasInStorage: 'AdressDatas',
  foldDatatablesParamsInStorage: 'foldDatatablesParams',
  treatmentChainsInStorage: 'treatmentChains',
  acceptedFilesInStorage: 'acceptedFiles',
  wso2: {
    clientId: 'tMff1oSaEQnY8BOC8ltrKk9q_rEa',
    clientIdMb: '0fThaXcRHKWyG4aK26VSNSYz3vAa',
    clientIdMetc: '98xxftBjhf5QFNNRYPUitwnUEOAa',
    clientIdBrc: 'SUAfUwKvVbRSeFXV1TfbmKzINcIa',
    wso2BaseUrl: 'https://numenexpress-ng.numenservices.fr',
    wso2AuthUrl: 'https://numenexpress-ng.numenservices.fr/oauth2/authorize',
    redirectUri: 'https://numenexpress-ng.numenservices.fr/auth-callback',
    tokenEndpoint: 'https://numenexpress-ng.numenservices.fr/oauth2/token',
    logoutEndpoint: 'https://numenexpress-ng.numenservices.fr/oidc/logout',
    post_logout_redirect_uri: 'https://numenexpress-ng.numenservices.fr',
    terminateSessionsEndpoint: 'https://numenexpress-ng.numenservices.fr/api/identity/session/terminate',
    scimUrl: 'https://numenexpress-ng.numenservices.fr/scim2/Users',
    scope: 'openid Nex email groups profile internal_user_mgt_create internal_user_mgt_view internal_user_mgt_list internal_user_mgt_delete internal_user_mgt_update internal_recovery_create internal_recovery_view internal_claim_meta_view internal_role_mgt_view internal_role_mgt_delete internal_role_mgt_create internal_role_mgt_update internal_user_recovery_create internal_group_mgt_create internal_group_mgt_view internal_group_mgt_update internal_group_mgt_delete'
  }
};
